import React from 'react';
import PropTypes from 'prop-types';
import Dialog, { withMobileDialog } from 'material-ui/Dialog';
import OfferPwdForm from './OfferPwdForm';

const OfferPwdDialog = ({
  fullScreen,
  open,
  handleClose,
  request,
  title,
  submitText,
  offerId,
  handleChangeOfferPassStatus,
}) => (
  <div>
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <OfferPwdForm
        request={request}
        title={title}
        handleClose={handleClose}
        submitText={submitText}
        offerId={offerId}
        handleChangeOfferPassStatus={handleChangeOfferPassStatus}
      />
    </Dialog>
  </div>
);

OfferPwdDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  request: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  offerId: PropTypes.string.isRequired,
  submitText: PropTypes.string,
  handleChangeOfferPassStatus: PropTypes.func,
};

OfferPwdDialog.defaultProps = {
  submitText: 'Submit',
};

export default withMobileDialog({
  breakpoint: 'xs',
})(OfferPwdDialog);



// WEBPACK FOOTER //
// ./src/components/Dashboard/OfferPwd/OfferPwdDialog.js